import React, { useState } from "react";
import { Card, Grid, Icon, InputText, Link, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
const StyledLink = styled(Link)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledGrid = styled(Grid)`
  max-height: 300px;
  overflow: auto;
`;
const TopicSummaryLinksCard = _ref => {
  let {
    links,
    initialLimit = 3,
    ...rest
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [limit, setLimit] = useState(initialLimit);
  const [query, setQuery] = useState("");
  let tempLinks = links;
  if (!tempLinks.length) {
    return null;
  }
  const exceededLimit = tempLinks.length > initialLimit;
  const exceededLimitBy = limit && tempLinks.length > limit ? tempLinks.length - limit : undefined;
  if (exceededLimitBy) {
    tempLinks = tempLinks.slice(0, limit);
  }
  const toggleLimit = () => {
    setLimit(prev => prev ? undefined : initialLimit);
    setQuery("");
  };
  const filteredLinks = tempLinks.filter(link => query === "" || link.toLowerCase().includes(query.toLowerCase()));
  return /*#__PURE__*/React.createElement(Card, rest, exceededLimit && !exceededLimitBy && /*#__PURE__*/React.createElement(InputText, {
    autoFocus: true,
    value: query,
    onChange: val => setQuery(val),
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    fullWidth: true,
    clearButton: true,
    s: {
      mb: 4
    }
  }), filteredLinks.length ? /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    gap: 2,
    template: "1rem 1fr"
  }, filteredLinks.map(link => /*#__PURE__*/React.createElement(React.Fragment, {
    key: link
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "link",
    s: {
      mt: 1,
      mr: 1
    }
  }), /*#__PURE__*/React.createElement(StyledLink, {
    href: link,
    color: colors.text.primary,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": link,
    underline: true
  }, link)))) : /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold",
    fontSize: 4,
    s: {
      my: 2
    }
  }, "No Links"), exceededLimit && /*#__PURE__*/React.createElement(Link, {
    onClick: toggleLimit,
    s: {
      mt: 2
    },
    weight: "semiBold",
    color: colors.text.secondary,
    underline: true
  }, exceededLimitBy ? `Show ${exceededLimitBy} more` : "Collapse list"));
};
export default TopicSummaryLinksCard;